/**
 * フォントと画像の読み込み完了を監視するクラス
 */
export class LoadingManager {
  private readonly kvElement: HTMLElement | null;

  constructor() {
    this.kvElement = document.querySelector('.ist-js__100thKv');
    this.init();
  }

  private init(): void {
    // Googleフォントの読み込みとKV内画像の読み込み完了を待機
    Promise.all([document.fonts.ready, this.waitForImages()]).then(() => {
      if (this.kvElement) {
        this.kvElement.classList.add('ist-js__100thKv--loaded');
      }
    });
  }

  private waitForImages(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.kvElement) {
        resolve();
        return;
      }
      const images = Array.from(this.kvElement.getElementsByTagName('img'));
      const loadedImages = images.filter((img) => img.complete).length;
      if (loadedImages === images.length) {
        resolve();
        return;
      }
      images.forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            if (images.every((img) => img.complete)) {
              resolve();
            }
          });
        }
      });
    });
  }
}
